'use client'

import type { CSSProperties, ReactNode } from 'react'
import { cx } from './utils/cx'

interface CheckboxProps {
  on?: boolean
  onChange?: (next: boolean) => void
  label?: ReactNode
  count?: ReactNode
  strike?: boolean
  className?: string
  style?: CSSProperties
  disabled?: boolean
}

export function Checkbox({ on, onChange, label, count, strike = true, className, style, disabled }: CheckboxProps) {
  const toggle = () => {
    if (!disabled) onChange?.(!on)
  }
  const box = (
    <span
      role="checkbox"
      aria-checked={!!on}
      aria-disabled={disabled || undefined}
      tabIndex={disabled ? -1 : 0}
      onClick={toggle}
      onKeyDown={(e) => {
        if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault()
          toggle()
        }
      }}
      className={cx('st-cbx', on && 'on', disabled && 'disabled')}
    />
  )
  if (label == null && count == null) {
    return (
      <span className={cx('st-cbx-wrap', className)} style={style}>
        {box}
      </span>
    )
  }
  return (
    <div
      className={cx('st-cbx-row', on && strike && 'done', disabled && 'disabled', className)}
      style={style}
      onClick={toggle}>
      {box}
      <span className="st-cbx-label">{label}</span>
      {count != null && <span className="st-cbx-count">{count}</span>}
    </div>
  )
}
